import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-amber-50 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxt7p0idz4i7">
        <div className="text-center" data-id="element-127" data-mp="2bk8pk3eq646a">
          <span className="inline-flex items-center gap-2 rounded-full border border-stone-200 bg-stone-100 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-stone-700" data-id="element-128" data-mp="2bj7dpwpvxdni">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="21ljhf2cmry38" /> Complete classroom coverage
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-green-950 sm:text-4xl" data-id="element-130" data-mp="1wnre7c6jcpjq">
            The {totalVolumes} comprehensive volumes
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="l7b8iaks9na2">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-stone-200 bg-white shadow-sm" data-id="element-132" data-mp="1it5vkyjbn9sd" data-mpi={index}>
                <div className="flex items-center gap-4 bg-green-900 px-6 py-5" data-id="element-133" data-mp="14vpnlildn7yi">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-amber-500 text-green-950" data-id="element-134" data-mp="q7373dk0ka5p">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v6fsruz5fb6p" />
                  </span>
                  <div data-id="element-136" data-mp="h6xy4yz693pf">
                    <p className="text-xs font-bold uppercase tracking-[.14em] text-amber-400" data-id="element-137" data-mp="h6ep67ri1pnj">Volume {module.number}</p>
                    <h3 className="mt-1 text-lg font-bold leading-tight text-stone-50" data-id="element-138" data-mp="l9b3vndx51m7">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2j2dvkrlo7do7">
                  <p className="font-semibold text-green-950" data-id="element-140" data-mp="2e4c2reyfzzzj">{module.subtitle}</p>

                  <p className="mt-5 text-xs font-bold uppercase tracking-[.12em] text-stone-500" data-id="element-141" data-mp="2e29a0n5wnsr4">
                    What does it solve in the classroom?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-stone-600" data-id="element-142" data-mp="36shpu8cyy12j">{module.context}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="31ug41fo5rnnd">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-stone-900" data-id="element-144" data-mp="2wwoe2r72qblt">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-green-700" aria-hidden="true" data-id="element-145" data-mp="2svkxg2h7cbjj" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-amber-500 bg-green-50 p-4 text-sm leading-relaxed text-green-950" data-id="element-146" data-mp="3t1ezczhx6sdq">
                    <b className="font-extrabold" data-id="element-147" data-mp="wuo6w8si0gt">Result: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-amber-900 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="aoh2j1gfcfns">
          <p className="text-xs font-bold uppercase tracking-[.16em] text-stone-100" data-id="element-149" data-mp="kllhohburav3">Main collection</p>
          <p className="text-2xl font-extrabold text-stone-50 sm:text-3xl" data-id="element-150" data-mp="on716liw6ne9">
            {totalVolumes} premium volumes <span className="mx-2 text-amber-400" data-id="element-151" data-mp="tm1h9fph5xuo">·</span> Updated for 2026
          </p>
        </div>
      </div>
    </section>;
}